import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../../constants/common'
import { useUserData } from '../../../../../../../hooks'
import {
  APPLICANT_PAYLOAD_FIELD,
  getMockListingApplicants,
} from '../../../../../../RentalPortalApplicant'
import { setMockListingApplicantsSeen } from '../../../../../../RentalPortalListing'
import { RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT } from '../../../../../RentalPortal.constants'
import {
  getIsRentalPortalPageReadCurrent,
  getRentalPortalPageReadKey,
} from '../../../../../RentalPortal.utils'
import { getHasApplicantsPayloadField } from '../../../../../RentalPortalApplicants'
import { LISTING_APPLICANTS_PAGE_SIZE } from '../../RentalPortalListingProfileApplicants.constants'

export function useListingProfileApplicants({ listingId }) {
  const currentUser = useUserData()

  const [page, setPage] = useState(1)
  const [reloadKey, setReloadKey] = useState(0)

  const [response, setResponse] = useState(null)
  const [hasError, setError] = useState(false)

  const [isInitiated, setInitiated] = useState(false)
  const [loadedReadKey, setLoadedReadKey] = useState(null)

  const readIdRef = useRef(0)

  const readKey = getRentalPortalPageReadKey([listingId, page, reloadKey])

  async function loadApplicants() {
    readIdRef.current += 1

    const readId = readIdRef.current

    return getMockListingApplicants({
      currentUser,
      listing_id: listingId,
      page,
      page_size: LISTING_APPLICANTS_PAGE_SIZE,
    })
      .then(({ data }) => {
        if (getIsRentalPortalPageReadCurrent({ readId, readIdRef })) {
          setResponse(data)
          setError(false)
          setPage(data.pagination.page)

          setMockListingApplicantsSeen(listingId)

          setLoadedReadKey(readKey)
          setInitiated(true)
        }
      })
      .catch(() => {
        if (getIsRentalPortalPageReadCurrent({ readId, readIdRef })) {
          setError(true)

          setLoadedReadKey(readKey)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    if (listingId) {
      loadApplicants()
    }
  }, [readKey])

  function handleSetPagination(nextPagination) {
    setPage(nextPagination.page)
  }

  async function handleRefresh() {
    setInitiated(false)
    setError(false)
    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  const items = response?.results?.objects ?? EMPTY_LIST

  return {
    allItems: response?.allItems ?? EMPTY_LIST,
    handleRefresh,
    handleSetPagination,
    hasError,
    hasStage: getHasApplicantsPayloadField({
      field: APPLICANT_PAYLOAD_FIELD.stage,
      items,
    }),
    isInitiated,
    isLoading: loadedReadKey !== readKey,
    items,
    pagination: {
      count: response?.pagination?.total ?? RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT,
      page,
      pageCount:
        response?.pagination?.page_count ?? RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT,
      pageSize: LISTING_APPLICANTS_PAGE_SIZE,
    },
  }
}
